import { Box, HStack } from "@chakra-ui/react";
import React from "react";
import LeftSidebar from "../../components/LeftSideBarLayout/LeftSideBar";
import HeaderBar from "../../components/Header/HeaderBar";
import ManufacturerInfo from "../../components/ManufacturerItems/ManufacturerItemsInfo";
import Footer from "../../components/footer";

const ManufacturerList = () => {
    return (
        <Box backgroundColor='#F0F4F9' minHeight="100vh">
            <HStack pl='20px' pr='6px' alignItems='flex-start' spacing={0} w="100%">
                <LeftSidebar />
                <Box as="main" flex="1" minW="0" ml="6px">
                    <HeaderBar />
                    <ManufacturerInfo />
                    <Footer />
                </Box>
            </HStack>
        </Box>
    );
};

export default ManufacturerList;